'use client';

import { c as _c } from "react/compiler-runtime";
import AnimateLines from '@components/animate-lines/AnimateLines';
import ButtonClose from '@components/button-close/ButtonClose';
import HeaderButtons from '@components/header-buttons/HeaderButtons';
import HeaderLogo from '@components/header-logo/HeaderLogo';
import ModalMenuRoutes from '@components/modal-menu-routes/ModalMenuRoutes';
import { handleOpenMenu, menuSelector } from '@lib/store/slices/ComponentsSlice';
import { CONTACTS } from '@lib/tools/helpers/constants';
import { useViewport } from '@lib/tools/hooks/useViewport';
import { animated, useSpring } from '@react-spring/web';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import style from './ModalMenu.module.scss';
const ModalMenu = () => {
  const $ = _c(27);
  const [toggle, setToggle] = useState(true);
  const [reverse, setReverse] = useState(false);
  const formRef = useRef();
  const {
    isMobile
  } = useViewport();
  const openModelForm = useSelector(menuSelector);
  const dispatch = useDispatch();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      duration: 600
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = toggle ? 0 : 1;
  const t2 = toggle ? -1000 : 0;
  let t3;
  if ($[1] !== t1 || $[2] !== t2) {
    t3 = {
      config: t0,
      opacity: t1,
      x: t2,
      delay: 0,
      loop: false
    };
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const opacityStyle = useSpring(t3);
  let t4;
  if ($[4] !== openModelForm) {
    t4 = () => {
      if (openModelForm) {
        setTimeout(() => {
          setToggle(false);
        }, 0);
        setTimeout(() => {
          setReverse(true);
        }, 200);
      } else {
        setReverse(false);
      }
    };
    $[4] = openModelForm;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== openModelForm || $[7] !== reverse) {
    t5 = [openModelForm, reverse];
    $[6] = openModelForm;
    $[7] = reverse;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  useEffect(t4, t5);
  let t6;
  if ($[9] !== dispatch) {
    t6 = () => {
      setToggle(true);
      setTimeout(() => {
        dispatch(handleOpenMenu(false));
      }, 500);
    };
    $[9] = dispatch;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const handleCloseFormModel = t6;
  let t7;
  if ($[11] !== handleCloseFormModel) {
    t7 = event => {
      if (event.key === "Escape") {
        handleCloseFormModel();
      }
    };
    $[11] = handleCloseFormModel;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const handleKeyPress = t7;
  let t8;
  let t9;
  if ($[13] !== handleKeyPress) {
    t8 = () => {
      document.addEventListener("keydown", event_0 => {
        handleKeyPress(event_0);
      });
      return () => document.removeEventListener("keydown", event_1 => {
        handleKeyPress(event_1);
      });
    };
    t9 = [handleKeyPress];
    $[13] = handleKeyPress;
    $[14] = t8;
    $[15] = t9;
  } else {
    t8 = $[14];
    t9 = $[15];
  }
  useEffect(t8, t9);
  let t10;
  let t11;
  if ($[16] !== openModelForm) {
    t10 = () => {
      if (openModelForm) {
        disableBodyScroll(document.body);
      }
      if (!openModelForm) {
        enableBodyScroll(document.body);
      }
    };
    t11 = [openModelForm];
    $[16] = openModelForm;
    $[17] = t10;
    $[18] = t11;
  } else {
    t10 = $[17];
    t11 = $[18];
  }
  useEffect(t10, t11);
  let t12;
  if ($[19] !== handleCloseFormModel || $[20] !== isMobile || $[21] !== opacityStyle || $[22] !== openModelForm || $[23] !== reverse) {
    t12 = openModelForm && <div className={style.formModal}><div onClick={() => handleCloseFormModel()} className={style.formModalBack} role="button" tabIndex="0" /><animated.div style={opacityStyle} className={style.formModalContainer} ref={formRef}><div className={style.formModal__box}><div className={style.formModal__top}><div className={style.formModal__routes__btn}><div className={style.formModal__route__btn}><HeaderLogo color="black" handleScrollTop={() => handleCloseFormModel()} openModelForm={openModelForm} /><HeaderButtons toggleWhite={true} headerColorScheme="" /></div></div><ButtonClose id="close_black" className={style.formModalBtnClose} handleFuction={handleCloseFormModel} /></div></div><div className={style.scrollableContent}><ModalMenuRoutes /><div className={style.formModal__links}><Link className={style.formModal__link} href={"mailto:" + CONTACTS.MAIL}>{CONTACTS.MAIL}</Link><Link suppressHydrationWarning={true} className={style.formModal__link} href={"tel:" + CONTACTS.PHONE}>{CONTACTS.PHONE}</Link></div></div><div className={style.gradient} />{!isMobile && <AnimateLines id="vector_9" className={style.formModal__svgClass} toggle={reverse} />}</animated.div></div>;
    $[19] = handleCloseFormModel;
    $[20] = isMobile;
    $[21] = opacityStyle;
    $[22] = openModelForm;
    $[23] = reverse;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12) {
    t13 = <>{t12}</>;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
};
export default ModalMenu;